module.exports = __webpack_public_path__ + "img/history.2815d581.png";